export enum DropdownEventType {
  MultiSelect,
  Dropdown,
}
